import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Link from 'shared/components/Link/Link';
import LINKS from 'desktop/constants/navigation';
import { userLogout } from 'shared/actions/user';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';

import { initOptimizeExperiment } from 'shared/helpers/abtesting';

import plusImg from 'shared/assets/images/add-plus-button-white.svg';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import NavigationItem from './NavigationItem/NavigationItem';
import ProfileButton from './ProfileButton/ProfileButton';

import s from './Navigation.css';

class Navigation extends React.Component {
  static propTypes = {
    user: PropTypes.shape(),
    history: PropTypes.shape(),
    current: PropTypes.shape(),
    userLogout: PropTypes.func.isRequired,
    shouldSetNoIndex: PropTypes.bool.isRequired,
    setDataLayer: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    history: {},
    current: null,
    shouldSetNoIndex: true,
  };

  state = {
    addLink: '/add/avto/',
    addRel: '',
  };

  componentDidMount = () => {
    initOptimizeExperiment('AddFormAB', value => {
      const addLinks = {
        '0': { link: '/add/avto/', rel: '' },
        '1': { link: '/addv2/avto/', rel: 'nofollow' },
      };
      if (value && addLinks[value]) {
        this.setState({
          addLink: addLinks[value].link,
          addRel: addLinks[value].rel,
        });
      }
    });
  };

  handleSellClick = () => {
    this.props.setDataLayer(EVENTS.sellCarButtonClick);
  };

  render() {
    const { user, history, current, shouldSetNoIndex } = this.props;
    const token = user && user.token;

    let { currentPath } = history;
    const currentRoute =
      current ||
      LINKS.HEADER.filter(a => {
        const route = (typeof a.route === 'string' && a.route) || '';
        currentPath = (typeof currentPath === 'string' && currentPath) || '';
        return new RegExp(`^${route}`, 'mi').test(currentPath);
      })[0];

    return (
      <div className={s.root} role="navigation">
        <div className={s.left}>
          <div className={s.flexRow}>
            {LINKS.HEADER.map((item, i) =>
              <div className={cx(s.navItem)} key={i}>
                <NavigationItem
                  item={item}
                  isActive={item === currentRoute}
                  eventPrefix={'headerNavigation'}
                />
              </div>,
            )}
          </div>
        </div>
        <div className={s.right}>
          <Link
            onClick={this.handleSellClick}
            className={cx(s.link, s.sell)}
            to={this.state.addLink}
            rel={this.state.addRel}
          >
            <img src={plusImg} width="16" height="16" alt="Продать" />&nbsp;<FormattedMessage id="Продать" />
          </Link>
          {token && user
            ? <ProfileButton logout={this.props.userLogout} user={user.user} />
            : <Link
                className={cx(s.link, s.highlight)}
                shouldSetNoIndex={shouldSetNoIndex}
                to="/login"
                rel="nofollow"
              >
                <FormattedMessage id="Войти" />
              </Link>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  userLogout: () => dispatch(userLogout()),
  setDataLayer: bindActionCreators(setDataLayer, dispatch),
});

const mapStateToProps = state => ({
  user: state.user,
  history: state.history,
});

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(Navigation));



// WEBPACK FOOTER //
// ./src/desktop/components/Navigation/Navigation.js